// Paleta discreta e fixa, sem escolher cor por nome — deriva da própria string,
// então continua consistente mesmo quando o admin cadastra um valor novo.
const PALETTE: { backgroundColor: string; color: string }[] = [
    { backgroundColor: '#E3F2FD', color: '#1565C0' },
    { backgroundColor: '#E0F2F1', color: '#00695C' },
    { backgroundColor: '#E8F5E9', color: '#2E7D32' },
    { backgroundColor: '#FFF3E0', color: '#E65100' },
    { backgroundColor: '#FFFDE7', color: '#F9A825' },
    { backgroundColor: '#FFEBEE', color: '#C62828' },
    { backgroundColor: '#F3E5F5', color: '#6A1B9A' },
    { backgroundColor: '#EFEBE9', color: '#4E342E' },
    { backgroundColor: '#E0F7FA', color: '#00838F' },
    { backgroundColor: '#EDE7F6', color: '#4527A0' },
];

const DEFAULT_COLOR = { backgroundColor: '#ECEFF1', color: '#455A64' };

export const getCategoryColor = (nome?: string): { backgroundColor: string; color: string } => {
    if (!nome) return DEFAULT_COLOR;
    let hash = 0;
    for (let i = 0; i < nome.length; i++) {
        hash = nome.charCodeAt(i) + ((hash << 5) - hash);
    }
    return PALETTE[Math.abs(hash) % PALETTE.length];
};
